export const header = {
    contactUs: 'Contáctanos',
    viewAll: 'Ver todo —',
    ariaMenu: 'Abrir menú',
    navItems: [
        {
            label: 'Por qué Venus', href: '/#why-venus', id: 'why-venus',
            children: [
                { label: 'Clima de Negocios', href: '/#business-climate' },
                { label: 'Condados Johnson/Ellis', href: '/#counties' },
                { label: 'Vivir en Venus', href: '/#venus-living' },
                { label: 'Asequibilidad', href: '/#affordability' },
                { label: 'Educación', href: '/#education' },
                { label: 'Historias de Éxito', href: '/#stories' },
                { label: 'Historia de Venus', href: '/history' },
            ],
        },
        {
            label: 'Selección de Sitio', href: '/#site-selection', id: 'site-selection',
            children: [
                { label: 'Demografía', href: '/#demographics' },
                { label: 'Industrias Clave', href: '/#key-industries' },
                { label: 'Comercio en Venus', href: '/#retail' },
                { label: 'Principales Empleadores', href: '/#employers' },
                { label: 'Transporte y Ubicación', href: '/#transportation' },
                { label: 'Servicios e Infraestructura', href: '/#utilities' },
                { label: 'Desarrollos Recientes', href: '/#recent-developments' },
            ],
        },
        {
            label: 'Recursos Empresariales', href: '/#business-resources', id: 'business',
            children: [
                { label: 'Expansión y Relocalización', href: '/#expansion' },
                { label: 'Iniciar un Negocio', href: '/#starting-business' },
                { label: 'Incentivos', href: '/#incentives' },
                { label: 'Tasas de Impuestos', href: '/#tax-rates' },
                { label: 'Investigación, Datos y Mapas', href: '/#research' },
                { label: 'Socios Comunitarios', href: '/#partners' },
                { label: 'Investigación de Empleo', href: '/#job-research' },
            ],
        },
        {
            label: 'Propiedades', href: '/#space', id: 'space',
            children: [
                { label: 'Búsqueda de Propiedades', href: '/#property-search' },
            ],
        },
        {
            label: 'Acerca de', href: '/#about-us', id: 'about',
            children: [
                { label: 'Lo Que Hacemos', href: '/#what-we-do' },
                { label: '¿Qué es un EDC?', href: '/#what-is-edc' },
                { label: 'Nuestro Equipo', href: '/#staff' },
                { label: 'Reuniones y Agendas', href: '/#meetings' },
                { label: 'Últimas Noticias', href: '/#news' },
                { label: 'Miembros del Consejo', href: '/#board' },
            ],
        },
    ],
};

export const hero = {
    subtitle: 'Desarrollo Económico',
    title1: 'Donde Todo ',
    titleSpan: 'Se Une',
    description: 'Venus, Texas ofrece un entorno estable y de bajo costo con una comunidad de apoyo, ideal para lanzar su nuevo negocio o expandir su presencia. Con un crecimiento sin precedentes y ubicación estratégica, descubra por qué las empresas eligen Venus.',
    ctaPrimary: 'Encuentra Tu Espacio',
    ctaSecondary: '¿Por Qué Venus?',
    stat1Label: 'Pies Cuadrados Industrial',
    stat2Label: 'al Centro de Dallas',
    stat3Label: 'Sitios para Desarrollo',
};

export const cityViews = {
    title: '¿Por qué ',
    titleSpan: 'Venus?',
    subtitle: 'Hace menos de una década, Venus era una comunidad dormitorio en crecimiento. Ya no. Hoy contamos con millones de pies cuadrados de espacio industrial, con más por venir en los próximos 18 meses.',
    readStory: 'Nuestra Historia',
    items: [
        { title: 'Clima de Negocios', description: 'El Ayuntamiento y la Venus Service Community Development Corporation (VSCDC) están aquí para ayudarle a crecer y expandir su negocio en Venus, Texas.' },
        { title: 'Oportunidades en Venus', description: 'Ya sea una empresa nueva o una corporación consolidada, la VSCDC le acompañará desde la ubicación del sitio hasta la gestión de permisos.' },
        { title: 'Amplio espacio para establecer negocios', description: 'La Ciudad de Venus ofrece propiedades comerciales de primer nivel a lo largo de la Autopista 67 y Main Street, desde centros de distribución hasta pequeñas propiedades comerciales.' },
        { title: 'Crecimiento continuo en los Condados Johnson/Ellis', description: 'Venus está al sur de Arlington, entre Fort Worth y Dallas, dentro de una de las áreas de mayor crecimiento del país.' },
        { title: 'Amigable con los Negocios', description: 'Venus tiene una mentalidad de servicio y pro-negocio, con el objetivo de ayudar a empresas y residentes a reubicarse aquí.' },
        { title: 'Vivir en Venus y Asequibilidad', description: 'Venus es una ciudad pequeña, vibrante y encantadora. La vivienda asequible garantiza que las personas puedan satisfacer sus necesidades básicas.' },
    ],
};

export const whyVenus = {
    businessClimate: {
        label: 'Por qué Venus',
        title: 'Clima de ',
        titleSpan: 'Negocios',
        subtitle: 'Una plaza activa, una economía en crecimiento y una comunidad hecha para los negocios.',
        photoCaption: 'Plaza de Venus — Centro de Venus, Texas',
        cards: [
            { icon: '📈', title: 'Crecimiento Rápido',  body: 'Venus es una de las ciudades de más rápido crecimiento en el área DFW, con expansión constante en población y comercio.' },
            { icon: '🏗',  title: 'Pro-Negocios',        body: 'Permisos ágiles, bajas tasas de impuestos y un ayuntamiento comprometido con el desarrollo económico hacen de Venus un destino de inversión.' },
            { icon: '🤝',  title: 'Comunidad Sólida',    body: 'Una comunidad empresarial activa, una EDC comprometida y una población receptiva crean el ambiente ideal para crecer.' },
        ],
    },
    venusLiving: {
        label: 'Vivir en Venus',
        title: 'Una Ciudad que Vale ',
        titleSpan: 'la Pena Llamar Hogar',
        p1: 'Venus es una ciudad pequeña, vibrante y encantadora ubicada en los condados de Johnson/Ellis. A solo 30 millas al sur de Dallas, Venus tiene fácil acceso a todas las comodidades del área metropolitana de Dallas/Fort Worth, manteniendo un ambiente familiar.',
        p2: 'Venus se desarrolló en la unión de los ferrocarriles International Great Northern y Gulf, Colorado and Santa Fe. El ferrocarril convirtió al pueblo en un centro de visitantes con comercio, tiendas y personas que querían quedarse. Hoy, la ciudad mantiene esa mentalidad amigable y encanto familiar, dando la bienvenida a nuevos negocios.',
    },
    affordability: {
        title: 'Vivienda ',
        titleSpan: 'Asequible',
        subtitle: 'La vivienda asequible garantiza que las personas puedan satisfacer sus necesidades básicas manteniendo acceso a otros elementos esenciales como alimentos, salud, educación y transporte.',
        ellisLabel: 'Condado Ellis',
        ellisSubLabel: 'Precio Mediano de Cierre',
        johnsonLabel: 'Condado Johnson',
        johnsonSubLabel: 'Precio Mediano de Cierre',
        source: 'Datos: Universidad Texas A&M, Centro de Investigación Inmobiliaria de Texas · Actualizado: Marzo 2026',
    },
    education: {
        label: 'Educación',
        title: 'Distrito Escolar ',
        titleSpan: 'Independiente de Venus',
        p1: 'El Distrito Escolar Independiente de Venus (VISD) fue fundado en 1914. Ubicado a 25 millas al sur de Dallas-Fort Worth, el VISD atiende a más de 2,300 estudiantes.',
        p2: 'El VISD ofrece una comunidad amigable con muchas oportunidades para que los estudiantes prosperen — haciendo de Venus un lugar ideal para que las familias echen raíces junto a su negocio.',
        cta: 'Visitar VISD',
    },
    stories: {
        title: 'Historias de ',
        titleSpan: 'Éxito',
        subtitle: 'Negocios locales que han encontrado su hogar — y su éxito — aquí mismo en Venus, Texas.',
    },
};

export const stats = {
    title: 'Selección de Sitio y ',
    titleSpan: 'Datos',
    subtitle: 'Venus ofrece un entorno estable y de bajo costo con una comunidad de apoyo, ideal para lanzar su nuevo negocio o hacer crecer el existente.',
    cta: 'Ver Demografía Completa',
    items: [
        { label: 'Población 2025' },
        { label: 'Ingreso Familiar Medio' },
        { label: 'Edad Mediana' },
        { label: 'Incremento Anual en Impuesto a Ventas' },
    ],
};

export const siteSelection = {
    title: 'Selección de ',
    titleSpan: 'Sitio',
    subtitle: 'Todo lo que necesita para tomar una decisión informada sobre ubicar su negocio en Venus, Texas.',
    demographics: {
        title: 'Demografía',
        body: 'Venus ha experimentado un rápido crecimiento en la última década porque las personas se sienten atraídas por el sentido de comunidad, y la tendencia no muestra señales de desaceleración. Venus da la bienvenida a su negocio. Con una población que se ha más que duplicado en los últimos 20 años, en solo 30 minutos las empresas tienen acceso a más de 95,000 empleados potenciales.',
        statsTitle: 'La Ciudad de Venus en Cifras',
        stats: {
            population: 'Población Total',
            employment: 'Tasa de Empleo',
            income: 'Ingreso Medio por Hogar',
            housing: 'Total de Viviendas',
            homeownership: 'Tasa de Propiedad de Vivienda',
            bachelors: 'Licenciatura o Superior',
            uninsured: 'Sin Cobertura Médica',
            medianAge: 'Edad Mediana',
            familySize: 'Tamaño Promedio de Familia',
            under18: 'Menores de 18 Años',
        },
        sourceCensus: 'Censo Decenal 2020.',
        sourceAcs: 'Encuesta sobre la Comunidad Estadounidense (ACS) 2024, estimados de 5 años.',
        estimatesTitle: 'Estimados Anuales de Población, abril 2020 a julio 2025',
        estimatesBase: 'Base de Estimados, 1 de abril de 2020',
        cityOfVenus: 'Ciudad de Venus',
        estimatesSource: 'Estimados de población al 1 de julio. Fuente: Oficina del Censo de EE. UU., División de Población, Annual Estimates of the Resident Population for Incorporated Places in Texas: April 1, 2020 to July 1, 2025 (SUB-IP-EST2025-POP-48). Publicado en mayo de 2026.',
        projectionsTitle: 'Proyecciones de Población por Condado',
        county: 'Condado',
        projectionYears: ['Abril 2020', 'Julio 2030', 'Julio 2040', 'Julio 2050', 'Julio 2060'],
        change: 'Cambio 2020–2060',
        pctChange: '% Cambio 2020–2060',
        projectionsSource: 'Fuente: Texas Demographic Center, consultado en octubre de 2026.',
    },
    keyIndustries: {
        title: 'Industrias Clave',
        body: 'Venus tiene una actitud pro-negocios y disposición para dar la bienvenida a nuevas empresas. La VSCDC se esfuerza por acompañar a su empresa y asegurarse de que Venus sea el lugar correcto, ya sea que su negocio busque reubicarse o expandirse.',
    },
    retail: {
        title: 'Comercio en Venus',
        body: 'Venus ha experimentado un tremendo crecimiento en el sector minorista. El constante aumento de la población, los precios de vivienda más bajos y la intersección de la Autopista 67 y FM 157 son factores clave en el comercio. La Ciudad de Venus ofrece propiedades comerciales de primera en la Autopista 67 y Main Street.',
    },
    employers: {
        title: 'Principales Empleadores',
        items: [
            { name: 'Venus ISD', detail: 'Mayor empleador de la ciudad' },
            { name: 'Ciudad de Venus', detail: 'Gobierno municipal y servicios' },
        ],
    },
    transportation: {
        title: 'Transporte y Ubicación',
        body: 'Venus, Texas está ubicada a 30 millas al sur del Distrito Central de Negocios de Dallas, con sus límites extendiéndose hacia los condados de Johnson y Ellis. Venus está justo en el corredor de la Autopista 67 entre Midlothian y Alvarado. Se proyecta que la SH 360 se alineará justo fuera de los límites de la ciudad, lo que impulsará aún más el crecimiento.',
    },
    utilities: {
        title: 'Servicios e Infraestructura',
        body: 'La Ciudad de Venus cuenta con una amplia gama de proveedores de servicios públicos. Donde sea que se ubique su negocio dentro de la ciudad, tendrá acceso a servicios confiables.',
    },
    recentDev: {
        title: 'Desarrollos Recientes',
        intro: 'Venus está creciendo rápido. Nuevos negocios que han elegido Venus incluyen:',
        moreChip: '+ más en construcción',
    },
};

export const businessResources = {
    title: 'Recursos ',
    titleSpan: 'Empresariales',
    subtitle: 'Todo lo que necesita para iniciar, crecer o reubicar su negocio en Venus, Texas.',
    expansion: {
        title: 'Expansión y Relocalización',
        body: 'La VSCDC se esfuerza por aumentar las oportunidades de empleo local que fortalecen la base tributaria a través del apoyo financiero para la relocalización y expansión de negocios. Ya sea una empresa nueva o una corporación consolidada, la VSCDC le acompañará desde la ubicación del sitio hasta la gestión del proceso de permisos.',
    },
    startingBusiness: {
        title: 'Iniciar un Negocio',
        intro: 'A continuación encontrará una lista de elementos a considerar al iniciar un nuevo negocio en Venus, Texas. Algunos elementos pueden no aplicar a su tipo de negocio específico.',
        categories: [
            {
                id: 'city-county',
                title: 'Ciudad de Venus y Condados de Johnson y Ellis',
                items: [
                    { name: 'Certificado de Nombre Asumido', desc: 'Si operará bajo un nombre asumido, debe registrarlo con el Secretario del Condado de Johnson o Ellis. Contacte a la oficina respectiva para verificar disponibilidad del nombre.', links: [{ label: 'Condado de Johnson', href: 'https://www.johnsoncountytx.org/departments/county-clerk' }, { label: 'Condado de Ellis', href: 'https://www.co.ellis.tx.us/164/County-Clerk' }] },
                    { name: 'Certificado de Ocupación', desc: 'Ningún edificio podrá ser ocupado o utilizado hasta que la Ciudad de Venus emita un Certificado de Ocupación.', links: [{ label: 'Ciudad de Venus', href: 'https://www.cityofvenus.org' }] },
                    { name: 'Servicios Públicos', desc: 'Información sobre conexión, tarifas y servicios de utilidades puede obtenerse en la Ciudad de Venus.', links: [{ label: 'Ciudad de Venus', href: 'https://www.cityofvenus.org' }] },
                    { name: 'Encuesta de Salarios del Área', desc: 'Esta información está disponible en la Oficina de Estadísticas Laborales.', links: [{ label: 'Bureau of Labor Statistics', href: 'https://www.bls.gov' }] },
                ],
            },
            {
                id: 'state',
                title: 'Requisitos del Estado de Texas',
                items: [
                    { name: 'Secretario de Estado de Texas', desc: 'Para certificados corporativos y trámites de incorporación o autorización de corporaciones extranjeras para operar en Texas.', links: [{ label: 'Secretary of State', href: 'https://www.sos.state.tx.us' }] },
                    { name: 'Licencias Estatales', desc: 'Verifique con el Estado si su tipo de negocio requiere permisos o licencias estatales.', links: [{ label: 'Texas.gov', href: 'https://www.texas.gov' }] },
                    { name: 'Impuestos sobre Ventas y Uso', desc: 'Contacte a la Oficina del Contralor de Texas para información sobre impuestos sobre ventas y otras leyes administradas por esa oficina.', links: [{ label: 'Texas Comptroller', href: 'https://comptroller.texas.gov' }] },
                    { name: 'Seguro de Desempleo, Impuestos y Beneficios', desc: 'Obtenga información de la Comisión de Fuerza Laboral de Texas sobre el seguro de desempleo, impuestos y beneficios para empleados.', links: [{ label: 'Texas Workforce Commission', href: 'https://www.twc.texas.gov' }] },
                ],
            },
            {
                id: 'federal',
                title: 'Requisitos y Regulaciones Federales',
                items: [
                    { name: 'Solicitar un EIN', desc: 'Obtenga el "Application for Employer Identification Number" (Formulario SS-4) del Servicio de Impuestos Internos.', links: [{ label: 'IRS — Solicitar EIN', href: 'https://www.irs.gov/businesses/small-businesses-self-employed/apply-for-an-employer-identification-number-ein-online' }] },
                    { name: 'Ley de Normas Laborales Justas (FLSA)', desc: 'Los empleadores deben mantener registros de salarios y horas, y exhibir los carteles requeridos donde los empleados puedan verlos.', links: [{ label: 'DOL — Guía FLSA', href: 'https://www.dol.gov/agencies/whd/flsa' }] },
                    { name: 'Oficina de Estadísticas Laborales', desc: 'Obtenga información sobre leyes relacionadas con empleadores y seguridad laboral.', links: [{ label: 'BLS', href: 'https://www.bls.gov' }] },
                    { name: 'Administración de Pequeñas Empresas', desc: 'Información sobre programas de gestión, contratación y préstamos para pequeñas empresas.', links: [{ label: 'SBA', href: 'https://www.sba.gov' }] },
                    { name: 'Ley de Seguridad y Salud Ocupacional', desc: 'Requisitos de la Ley OSHA de 1970, disponibles en OSHA o el Departamento de Seguros de Texas.', links: [{ label: 'OSHA', href: 'https://www.osha.gov' }, { label: 'Texas Dept. of Insurance', href: 'https://www.tdi.texas.gov' }] },
                ],
            },
            {
                id: 'industry',
                title: 'Requisitos Específicos por Industria',
                items: [
                    { name: 'Comisión de Bebidas Alcohólicas de Texas', desc: 'Licencias y tarifas para la venta, transporte o almacenamiento de bebidas alcohólicas.', links: [{ label: 'TABC', href: 'https://www.tabc.texas.gov' }] },
                    { name: 'Permisos de Salud', desc: 'Las empresas que manipulen, procesen, empaquen o almacenen alimentos deben obtener permisos de salud de la Ciudad de Venus.', links: [{ label: 'Ciudad de Venus', href: 'https://www.cityofvenus.org' }] },
                    { name: 'Procedimientos de Importación y Exportación', desc: 'Información sobre procedimientos de importación y exportación a través de la División de Comercio Internacional o el SBDC.', links: [{ label: 'International Trade', href: 'https://www.trade.gov' }, { label: 'SBDC', href: 'https://www.txsbdc.org' }] },
                    { name: 'Requisitos de Calidad Ambiental', desc: 'Requisitos de control ambiental disponibles en TCEQ o la EPA.', links: [{ label: 'TCEQ', href: 'https://www.tceq.texas.gov' }, { label: 'EPA', href: 'https://www.epa.gov' }] },
                ],
            },
            {
                id: 'sbdc',
                title: 'Centros de Desarrollo de Pequeñas Empresas — Norte de Texas',
                items: [
                    { name: 'Small Business Administration', desc: 'Información sobre inicio y todos los aspectos de operar una pequeña empresa, con programas descargables.', links: [{ label: 'SBA', href: 'https://www.sba.gov' }] },
                    { name: 'Texas Economic Development Corporation', desc: 'La marca oficial de la División de Desarrollo Económico de Texas dentro de la Oficina del Gobernador.', links: [{ label: 'Texas EDC', href: 'https://gov.texas.gov/business' }] },
                    { name: 'Texas SBDC Network', desc: 'La Red de Centros de Desarrollo de Pequeñas Empresas de Texas — conocimiento, herramientas y recursos para triunfar.', links: [{ label: 'Texas SBDC', href: 'https://www.txsbdc.org' }] },
                    { name: 'Texas.gov', desc: 'Compilación de información necesaria para iniciar un nuevo negocio en Texas.', links: [{ label: 'Texas.gov', href: 'https://www.texas.gov' }] },
                    { name: 'SCORE', desc: 'Mentoría gratuita y recursos de asistencia para el inicio de pequeñas empresas.', links: [{ label: 'SCORE', href: 'https://www.score.org' }] },
                    { name: 'Texas Workforce Commission', desc: 'Red local/estatal dedicada al desarrollo de la fuerza laboral de Texas.', links: [{ label: 'TWC', href: 'https://www.twc.texas.gov' }] },
                    { name: 'Texas Manufacturing Assistance Center (TMAC)', desc: 'Recurso local para enfrentar los desafíos del competitivo entorno empresarial actual.', links: [{ label: 'TMAC', href: 'https://www.tmac.org' }] },
                    { name: 'Dallas Black Chamber of Commerce', desc: 'Defensor de la creación, crecimiento y bienestar de negocios afroamericanos en la comunidad de Dallas.', links: [{ label: 'Dallas Black Chamber', href: 'https://www.dallasblackchamber.org' }] },
                    { name: 'Greater Dallas Hispanic Chamber of Commerce', desc: 'Recurso empresarial, foro y defensor de los negocios hispanos en el área de Dallas.', links: [{ label: 'Hispanic Chamber', href: 'https://gdahcc.com' }] },
                    { name: "Women's Business Centers", desc: "Información y recursos de la SBA para negocios propiedad de mujeres.", links: [{ label: "Women's Business Centers", href: 'https://www.sba.gov/local-assistance/resource-partners/womens-business-centers' }] },
                    { name: 'FranNet — Consultores de Franquicias', desc: 'Empresa de consultoría que evalúa posibles negocios de franquicia para propietarios potenciales.', links: [{ label: 'FranNet', href: 'https://frannet.com' }] },
                    { name: 'American Association of Franchisees & Dealers', desc: 'Recursos para entender y explorar oportunidades de negocio en franquicias.', links: [{ label: 'AAFD', href: 'https://www.aafd.org' }] },
                    { name: 'Guía SBA para Iniciar Negocios', desc: 'Sección completa de recursos de la SBA para comenzar su negocio.', links: [{ label: 'SBA Business Guide', href: 'https://www.sba.gov/business-guide' }] },
                    { name: 'Intuit QuickBooks Small Business Center', desc: 'Compilación de recursos de finanzas, Recursos Humanos y marketing para pequeñas empresas.', links: [{ label: 'QuickBooks SBC', href: 'https://quickbooks.intuit.com/r/small-business-center/' }] },
                ],
            },
        ],
    },
    incentives: {
        title: 'Incentivos',
        items: [
            { name: 'Subsidio para Mejora de Edificios (BIG)', desc: 'Apoyo financiero para mejorar edificios existentes.' },
            { name: 'Solicitud de Incentivo al Desarrollo Económico', desc: 'Aplique para paquetes de incentivos personalizados.' },
            { name: 'Exención de Impuestos', desc: 'Reduzca los impuestos a la propiedad durante su fase de crecimiento.' },
            { name: 'Acuerdo del Capítulo 380', desc: 'Acuerdos de reembolso de impuesto a ventas para negocios calificados.' },
            { name: 'Zona de Reinversión de Incremento Tributario (TIRZ)', desc: 'Reinvierte los incrementos tributarios para apoyar el desarrollo.' },
        ],
    },
    taxRates: {
        title: 'Tasas de Impuestos',
        asOf: 'al 1 de octubre de 2026',
        propSubtitle: 'Tasa de Impuesto a la Propiedad (por $100 de valor)',
        salesSubtitle: 'Tasa de Impuesto a Ventas y Uso',
        propRates: [
            { label: 'Condado Johnson', rate: '$0.417000 por $100' },
            { label: 'Condado Ellis', rate: '$0.273500 por $100' },
            { label: 'Ciudad de Venus', rate: '$0.785967 por $100' },
            { label: 'Venus ISD', rate: '$1.237100 por $100' },
        ],
        salesRates: [
            { label: 'Ciudad de Venus', rate: '2.00%' },
            { label: 'Estado de Texas', rate: '6.25%' },
            { label: 'Total', rate: '8.25%', bold: true },
        ],
    },
    research: {
        title: 'Investigación, Datos y Mapas',
        maps: ['Mapa de Zonificación', 'Mapa de Uso Futuro del Suelo', 'Superposición Histórica'],
    },
    partners: {
        title: 'Socios Comunitarios',
        items: ['Desarrollo y Capacitación de Personal', 'Departamento de Planeación', 'Departamento de Construcción', 'Obras Públicas'],
    },
    jobResearch: {
        title: 'Investigación de Empleo',
        links: [
            { name: 'Liga Municipal de Texas', href: 'https://www.tml.org' },
            { name: 'Work in Texas', href: 'https://www.workintexas.com' },
        ],
    },
};

export const properties = {
    title: 'Encuentra Tu ',
    titleSpan: 'Espacio',
    subtitle: 'Ya sea que busque una instalación industrial a medida o un local comercial encantador, Venus tiene la ubicación perfecta para su negocio.',
    forSale: 'En Venta',
    forLease: 'En Arrendamiento',
    listings: 'propiedades',
    viewDetails: 'Ver detalles',
    cards: [
        { title: 'Búsqueda de Propiedades', desc: 'Explore nuestra base de datos de propiedades comerciales e industriales disponibles en Venus.', cta: 'Buscar Propiedades' },
        { title: 'Espacio Industrial', desc: '3.5 millones de pies cuadrados de espacio industrial listos para manufactura o distribución.', cta: 'Más Información' },
        { title: 'Comercio y Centro', desc: 'Únase a la vibrante mezcla de tiendas locales y marcas nacionales en nuestros corredores comerciales.', cta: 'Más Información' },
    ],
};

export const aboutUs = {
    title: 'Acerca de ',
    titleSpan: 'Nosotros',
    whatWeDo: {
        title: 'Lo Que Hacemos',
        body: 'La Venus Community Service Development Corporation se esfuerza por aumentar las oportunidades de empleo local que fortalecen la base tributaria a través del apoyo financiero para la relocalización y expansión de negocios. La VSCDC trabaja proactivamente para ayudar a las empresas existentes y nuevas a desarrollarse y prosperar, creando oportunidades para un crecimiento sostenible.',
    },
    missionStatement: {
        title: 'Declaración de Misión',
        body: 'Promover el desarrollo económico y el bienestar comunitario en la Ciudad de Venus a través del desarrollo estratégico de negocios, turismo, parques y entretenimiento.',
    },
    whatIsEdc: {
        title: '¿Qué es un EDC?',
        intro: 'Una Corporación de Desarrollo Económico (EDC, por sus siglas en inglés) es un vehículo financiado por impuestos sobre ventas mediante el cual las comunidades pueden participar en actividades de desarrollo económico y comunitario. Las EDC crean programas de desarrollo, construyen infraestructura, capacitan a la fuerza laboral local, fomentan alianzas con otras entidades gubernamentales y emprenden proyectos que mejoran la calidad de vida de los residentes.',
        sections: [
            {
                id: 'types',
                title: 'Corporaciones Tipo A vs. Tipo B',
                body: 'Existen dos tipos de corporaciones según el tamaño de la comunidad y cómo desea utilizar sus ingresos por impuestos sobre ventas. La tasa mínima es 1/8 del uno por ciento. Las ciudades pueden tener ambos tipos; sin embargo, el impuesto local combinado no puede exceder el 2%.',
                subsections: [
                    { name: 'EDC Tipo A', content: 'Más restringida en los tipos de proyectos que puede financiar. Solo puede formarse en condados con menos de 500,000 habitantes.', list: null },
                    { name: 'EDC Tipo B', content: 'Más flexible — amplía los usos para incluir una amplia gama de proyectos de desarrollo económico, mejoras de infraestructura e iniciativas de calidad de vida. Puede formarse en cualquier ciudad de Texas, sin importar su tamaño o ubicación.', list: null },
                ],
                list: null,
            },
            {
                id: 'sales-tax',
                title: '¿Quién Recauda los Impuestos sobre Ventas?',
                body: 'El impuesto es recaudado por la Contraloría de Cuentas Públicas de Texas. El 6.250% es el impuesto estatal sobre ventas. Las comunidades locales y las EDC pueden optar por agregar un impuesto adicional de hasta el 2% para un total de 8.250%. Una parte de este 2% adicional es lo que las EDC utilizan para financiar proyectos y gastos operativos.',
                subsections: null,
                list: null,
            },
            {
                id: 'primary-job',
                title: '¿Qué se Define como un Empleo Primario?',
                body: 'Un empleo primario es una posición en una empresa cuya mayoría de productos o servicios se exportan a mercados regionales, estatales, nacionales o internacionales, inyectando nuevos recursos a la economía local. Debe estar incluido en uno de los siguientes sectores del Sistema de Clasificación Industrial de América del Norte (NAICS):',
                subsections: null,
                list: ['Producción agrícola', 'Producción animal', 'Silvicultura y tala', 'Pesca comercial', 'Actividades de apoyo a la agricultura y silvicultura', 'Minería', 'Servicios públicos', 'Manufactura', 'Comercio al por mayor', 'Transporte', 'Almacenamiento', 'Servicios de información y datos', 'Valores, commodities, seguros y actividades financieras', 'Investigación científica', 'Servicios de desarrollo', 'Empresas de gestión', 'Centros de llamadas telefónicas', 'Instituciones correccionales', 'Seguridad nacional'],
            },
            {
                id: 'type-a-projects',
                title: 'Proyectos de EDC Tipo A',
                body: null,
                list: null,
                subsections: [
                    {
                        name: 'Proyectos de Empleo Primario',
                        content: 'Incluyen terrenos, edificios, equipos, instalaciones, mejoras y gastos para la creación y retención de "empleos primarios" — adecuados para:',
                        list: ['Manufactura', 'Industrial', 'Investigación y Desarrollo', 'Reciclaje', 'Pequeños almacenes', 'Centros de distribución', 'Sedes corporativas regionales o nacionales', 'Bases militares cerradas o reubicadas', 'Instalaciones de capacitación laboral por instituciones de educación superior'],
                    },
                    {
                        name: 'Proyectos de Empleo No Primario',
                        content: null,
                        list: ['Clases de capacitación laboral y centros de carrera', 'Instalaciones aeroportuarias de negocios y portuarias', 'Limpieza de sitios contaminados (con elección especial)', 'Asistencia de infraestructura a proyectos comerciales', 'Servicios de alcantarillado y mejoras de sitio', 'Remediación de playas en comunidades del Golfo', 'Proyectos para atraer o retener misiones militares', 'Instalaciones aeroportuarias a 25 millas de la frontera México-EE.UU.', 'Tren ligero, tren de cercanías y autobuses', 'Instalaciones para eventos deportivos (con elección especial)', 'Cualquier proyecto Tipo B mediante elección especial y aprobación de votantes'],
                    },
                ],
            },
            {
                id: 'type-b-projects',
                title: 'Proyectos de EDC Tipo B',
                body: null,
                subsections: null,
                list: ['Todo lo autorizado bajo Tipo A, incluyendo proyectos comerciales y minoristas', 'Instalaciones de suministro de agua (con elección especial)', 'Proyectos para mejorar la "calidad de vida" — parques, instalaciones deportivas, turismo y entretenimiento', 'Proyectos de vivienda asequible', 'Cualquier mejora que promueva "nuevos o ampliados negocios" que creen o retengan "empleos primarios"', 'Incentivos directos para comercio minorista en comunidades con menos de 200,000 residentes', 'Instalaciones de alcantarillado en el Condado de Hidalgo', 'Hangares, mantenimiento aeroportuario, instalaciones de carga aérea e infraestructura relacionada', 'Puertos ferroviarios, instalaciones de maniobras, puertos marítimos y puertos interiores'],
            },
            {
                id: 'incentives',
                title: 'Incentivos Locales de Desarrollo Económico',
                body: null,
                list: null,
                subsections: [
                    {
                        name: 'Acuerdos de Desempeño',
                        content: 'Las EDC no pueden simplemente otorgar fondos de impuestos sobre ventas. Se requiere un acuerdo de desempeño (contrato) bajo el Capítulo 501 del Código de Gobierno Local de Texas antes de proporcionar fondos. Debe ser aprobado por la junta directiva de la EDC y el Consejo Municipal. El acuerdo debe:',
                        list: ['Ser firmado por las partes', 'Establecer un cronograma de nómina adicional, empleos o métricas de impacto económico', 'Detallar en cifras la inversión de capital a realizar por la empresa', 'Contener el monto de fondos o incentivos proporcionados', 'Incluir términos de reembolso si la empresa no cumple sus obligaciones', 'Contener los descargos legales requeridos bajo el Código Fiscal, de Gobierno y de Gobierno Local de Texas'],
                    },
                    { name: 'Acuerdo Capítulo 380 (para ciudades)', content: 'Préstamos para infraestructura y otras mejoras diseñadas para el desarrollo económico.', list: null },
                    { name: 'Acuerdo Capítulo 381 (para condados)', content: 'Permite contratar con entidades privadas para compartir gastos de infraestructura, servicios públicos y planificación.', list: null },
                    { name: 'Exención de Impuesto a la Propiedad', content: 'Bajo los Capítulos 311–313 del Código Fiscal de Texas, las ciudades y condados pueden iniciar una exención fiscal que permita a una empresa pagar una parte de los impuestos sobre la propiedad por un período fijo. Los acuerdos de exención no pueden exceder diez (10) años.', list: null },
                    { name: 'Zona de Reinversión de Incremento Tributario (TIRZ)', content: 'Bajo el Capítulo 311 del Código Fiscal de Texas, el TIRZ ayuda a atender necesidades como estructuras deterioradas, caminos en mal estado, aceras, condiciones insalubres o inseguras, u otras condiciones defectuosas en propiedades, estructuras o servicios públicos.', list: null },
                ],
            },
        ],
    },
    staff: { title: 'Nuestro Equipo' },
    directorBadge: 'Director EDC',
    directorOrg: 'Venus Community Service Development Corporation',
    directorCta: 'Ver perfil completo →',
    board: { title: 'Miembros del Consejo' },
    viewProfile: 'Ver perfil →',
    vacantName: 'Vacante',
    vacantRole: 'Miembro del Consejo',
    meetings: {
        title: 'Reuniones y Agendas',
        body: 'Las minutas y agendas oficiales se publican en el sitio web de la Ciudad de Venus.',
        cta: 'Ver Minutas y Agendas →',
    },
    news: { title: 'Últimas Noticias' },
    contact: {
        title: 'Contacto',
        addressLabel: 'Dirección',
        phoneLabel: 'Teléfono',
        readyText: '¿Listo para comenzar en Venus? Comuníquese con nosotros llamando o enviando un mensaje.',
        sendMessage: 'Enviar Mensaje',
    },
};

export const footer = {
    tagline: 'Fomentando el crecimiento y apoyando a la comunidad. Experimente el encanto, abrace el futuro.',
    quickLinks: 'Enlaces Rápidos',
    links: ['Por qué Venus', 'Selección de Sitio', 'Recursos Empresariales', 'Propiedades', 'Acerca de'],
    contactUs: 'Contáctanos',
    allRights: 'Venus Economic Development Corporation. Todos los derechos reservados.',
};

export const contactModal = {
    title: 'Contáctanos',
    subtitle: 'Complete el formulario y un miembro de nuestro equipo se pondrá en contacto pronto.',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo Electrónico',
    phone: 'Teléfono',
    company: 'Empresa / Organización',
    companyPlaceholder: 'Opcional',
    message: 'Mensaje',
    messagePlaceholder: '¿En qué podemos ayudarle?',
    submit: 'Enviar Mensaje',
    sending: 'Enviando…',
    successTitle: '¡Mensaje Enviado!',
    successBody: 'Gracias por comunicarse con nosotros. Le responderemos en 1–2 días hábiles.',
    errorBody: 'Algo salió mal. Intente de nuevo o escríbanos directamente a contact@venustxedc.com',
    close: 'Cerrar',
    required: 'Campo requerido',
};

export const boardMemberProfile = {
    notFound: 'Miembro no encontrado',
    backHome: '← Volver al inicio',
    backTeam: '← Regresar al equipo',
    about: 'Acerca de',
    achievements: 'Logros',
    contact: 'Contacto',
    phone: 'Teléfono',
    email: 'Email',
    org: 'Organización',
    address: 'Dirección',
    orgValue: 'Venus Community Service\nDevelopment Corporation',
    addressValue: '700 W US Highway 67\nVenus, Texas 76084',
    sendMessage: 'Enviar mensaje',
    formName: 'Tu nombre',
    formEmail: 'Tu email',
    formMessage: 'Tu mensaje',
    formSend: 'Enviar',
    messageSent: 'Mensaje enviado. Gracias.',
};
